import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/Knowledge.css";

import event1Image from "../../assets/Kn.png";
import event2Image from "../../assets/knowledge3.png";
import knowledge from "../../assets/know.mp4";

import ServicesKnoweldgeRegister from "../ServicesKnoweldgeRegister";

const Knowledge = () => {
  const events = [
    {
      image: event1Image,
      title: "KNOWLEDGE SHARING",
      organizer: "Y. Siva Krishna",
      speaker: "K. Rajasekhar",
      eventmode: "In Person",
      schedule: "Aug 20 - Aug 23",
      time: "10AM - 4PM",
      location: "Ameerpet",
    },
    {
      image: event2Image,
      title: "KNOWLEDGE SHARING",
      organizer: "Y. Siva Krishna",
      speaker: "K. Rajasekhar",
      eventmode: "Online",
      schedule: "Jun 20 - Jun 23",
      time: "10AM - 4PM",
      location: "Ameerpet",
    },
  ];

  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <section className="knowledge-wrapper" id="knowledge">
        <div className="knowledge-section">

          {/* =====================================================
              HERO SECTION
              CONTENT LEFT + VIDEO RIGHT
          ===================================================== */}

          <div className="knowledgeshare123-hero">

            {/* =================================================
                LEFT - CONTENT
            ================================================= */}

            <div className="knowledgeshare123-hero-content">

              <h1 className="knowledge-title">
                KNOWLEDGE <strong>SHARING</strong>
              </h1>

              <div className="knowledgeshare123-title-line"></div>

              <p className="knowledge-description">
                We offer tailored knowledge-sharing solutions that foster
                collaboration and streamline resources. Our platforms enable
                teams to innovate and make informed decisions.
              </p>

              <p className="knowledge-description knowledgeshare123-description-second">
                By tapping into collective expertise, we help businesses
                drive productivity and growth, empowering organizations to
                turn knowledge into action.
              </p>

            </div>

            {/* =================================================
                RIGHT - VIDEO
            ================================================= */}

            <div className="knowledgeshare123-hero-video">

              <div className="knowledgeshare123-video-container">

                <video
                  src={knowledge}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="knowledge-video"
                />

              </div>

            </div>

          </div>


          {/* =====================================================
              KNOWLEDGE EVENT CARDS — UNCHANGED
          ===================================================== */}

          <div className="jobs-list">

            <div className="jobs-grid">

              {events.map((event, index) => (

                <div
                  className="knowledge-event-card"
                  key={index}
                >

                  {/* =================================================
                      LEFT - EVENT CONTENT
                  ================================================= */}

                  <div className="knowledge-event-content">

                    {/* EVENT TITLE */}

                    <h3 className="knowledge-event-title">
                      {event.title}
                    </h3>

                    <div className="job-title-line"></div>


                    {/* ORGANIZER */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        👤
                      </span>

                      <span>
                        Organizer:
                        <strong>{event.organizer}</strong>
                      </span>

                    </div>


                    {/* SPEAKER */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        🎤
                      </span>

                      <span>
                        Speaker:
                        <strong>{event.speaker}</strong>
                      </span>

                    </div>


                    {/* EVENT MODE */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        💻
                      </span>

                      <span>
                        Event Mode:
                        <strong>{event.eventmode}</strong>
                      </span>

                    </div>


                    {/* SCHEDULE */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        📅
                      </span>

                      <span>
                        Schedule:
                        <strong>{event.schedule}</strong>
                      </span>

                    </div>


                    {/* TIME */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        🕐
                      </span>

                      <span>
                        Time:
                        <strong>{event.time}</strong>
                      </span>

                    </div>


                    {/* LOCATION */}

                    <div className="job-detail">

                      <span className="job-detail-icon">
                        📍
                      </span>

                      <span>
                        Location:
                        <strong>{event.location}</strong>
                      </span>

                    </div>


                    {/* REGISTER BUTTON */}

                    <button
                      type="button"
                      className="knowledge-register-btn"
                      onClick={openPopup}
                    >
                      REGISTER NOW

                      <span className="register-arrow">
                        →
                      </span>

                    </button>

                  </div>


                  {/* =================================================
                      RIGHT - EVENT IMAGE
                  ================================================= */}

                  <div className="knowledge-event-image-wrapper">

                    <img
                      src={event.image}
                      alt={`${event.title} event`}
                      className="knowledge-event-image"
                    />

                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          REGISTRATION POPUP
      ===================================================== */}

      <ServicesKnoweldgeRegister
        show={showPopup}
        onClose={closePopup}
      />
    </>
  );
};

export default Knowledge;